import { createSlice } from '@reduxjs/toolkit';

export const websiteSlice = createSlice({
  name: 'websiteSlice',
  initialState: {
    title: '',
    websiteInformation: '',
    stats: {
      isAutogeneratedUrl: true,
      isLimitsEnabled: false,
      url: '',
      scan: '',
      micrositeData: null,
    },
  },
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    setMicrositeData(state, action) {
      state.micrositeData = action.payload;
    },
    setWebsiteInformation(state, action) {
      state.websiteInformation = action.payload;
    },
    setStats(state, action) {
      state.stats[action.payload.field] = action.payload.value;
    },
    setStatsData(state, action) {
      state.stats = action.payload;
    },
    setRenderedMicrositeData(state, action) {
      state.title = action.payload.title;
      state.websiteInformation = action.payload.websiteInformation;
      state.stats = action.payload.stats;
    },
    resetState: () => websiteSlice.getInitialState(),
  },
});

export default websiteSlice.reducer;
